import React, { useEffect } from 'react';

function MainPage () {
	useEffect(() => {
		window.document.title = 'Главная';
	});
	return (
		<div />
	);
}

export default MainPage;
